import { gql } from "@apollo/client";

const RaceTrackFragments = {
  entry: gql`
    fragment RaceTrack on Race {
      track {
        id
        trackName: name
        trackCode: code
        perfAbbr
        shortName
        featured
        numberOfRaces
        trackLocation: location {
          country
        }
        trackDataSource
      }
    }
  `
};

export default RaceTrackFragments;
